import React from 'react';
import { BudgetExpenseOrIncome } from 'business/constants';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import Chart from 'components/ChartContainer/components/Chart/Chart';
import ChartMessage from 'components/ChartContainer/components/Chart/ChartMessage';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import { ChartSettingsT } from 'business/definitions';
import {
    GESTIONNAIRE_SOFTWARE_ID,
    OPERATION_NAME_FIELD,
    ORG_CHART_FINANCE_SOFTWARE_ID,
} from 'routes/BudgetModule/config/constants';
import {
    BudgetVentilatedDataT,
    BudgetVentilatedDataWithCadrageT,
} from 'routes/BudgetModule/config/types';

type Props = {
    queryElement: QueryT;
    data: BudgetVentilatedDataWithCadrageT[] | BudgetVentilatedDataT[];
    columns: ResponseColumnT[];
    metricColumnKey: string;
    settings: ChartSettingsT;
};

const PieChart = ({
    data,
    columns,
    queryElement,
    metricColumnKey,
    settings,
}: Props): React.ReactElement => {
    const { t } = useTranslation();

    if (_.isEmpty(data) || _.isEmpty(columns))
        return <ChartMessage>{t('common.noData')}</ChartMessage>;

    const expenseData = data.map((row) =>
        _.pickBy(row, (value, key) => key !== BudgetExpenseOrIncome.INCOME),
    );
    const expenseColumns = columns.filter(
        (col) => col.key !== BudgetExpenseOrIncome.INCOME,
    );

    return (
        <ErrorBoundary>
            <Chart
                columns={expenseColumns}
                data={expenseData}
                applyChartSettings={() => {}}
                chartKey={-1}
                vizType="pie"
                queryMetrics={queryElement.metrics.map((metric) => ({
                    ...metric,
                    field: metricColumnKey,
                }))}
                queryDimensions={queryElement.dimensions.filter(
                    (dimension) =>
                        dimension.field === ORG_CHART_FINANCE_SOFTWARE_ID ||
                        dimension.field === GESTIONNAIRE_SOFTWARE_ID ||
                        dimension.field === OPERATION_NAME_FIELD,
                )}
                queryFilters={queryElement.filters}
                settings={settings}
                showDetailsModal={() => {}}
                onFormatVizDataFailed={() => {}}
                shouldForceVizType
            />
        </ErrorBoundary>
    );
};
export default PieChart;
